import { render } from "./PrintSignatoryBlock.vue?vue&type=template&id=4ffae28d"
import script from "./PrintSignatoryBlock.vue?vue&type=script&lang=js"
export * from "./PrintSignatoryBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__